import { render, staticRenderFns } from "./ModalComponent.component.html?vue&type=template&id=380edb18&"
import script from "./ModalComponent.component.ts?vue&type=script&lang=ts&"
export * from "./ModalComponent.component.ts?vue&type=script&lang=ts&"
import style0 from "./ModalComponent.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports